(function() {
  var DialogController,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.LimeController = (function(superClass) {
    extend(LimeController, superClass);

    function LimeController(scope, transitions, modalInstance, service) {
      var i, ref, ref1, results;
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.service = service;
      LimeController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);

      /*
          Get the previous 5 years plus the current year
       */
      this.scope.years = (function() {
        results = [];
        for (var i = ref = this.service.year, ref1 = this.service.year - 6; ref <= ref1 ? i < ref1 : i > ref1; ref <= ref1 ? i++ : i--){ results.push(i); }
        return results;
      }).apply(this);
      this.scope.service = this.service;
      this.previousValues = {
        lime_years_applied: this.service.fpcResult.data.lime_years_applied,
        lime_years_will_be_applicable: this.service.fpcResult.data.lime_years_will_be_applicable,
        lime_amount_applied: this.service.fpcResult.data.lime_amount_applied
      };
    }

    LimeController.prototype.save = function() {
      this.service.save(this.service.state.params.id);
      return this.modalInstance.dismiss('cancel');
    };

    LimeController.prototype.cancel = function() {
      this.service.fpcResult.data.lime_years_applied = this.previousValues.lime_years_applied;
      this.service.fpcResult.data.lime_years_will_be_applicable = this.previousValues.lime_years_will_be_applicable;
      this.service.fpcResult.data.lime_amount_applied = this.previousValues.lime_amount_applied;
      return this.modalInstance.dismiss('cancel');
    };

    return LimeController;

  })(DialogController);

}).call(this);
